import React from 'react'

const PrayIcon = props => (
  <svg viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g opacity="0.3" clipPath="url(#clip0)">
      <path
        d="M7.51243 1.16152C7.61809 1.26439 7.68608 1.39164 7.71602 1.526C7.74903 1.50171 7.78401 1.48076 7.82016 1.46251C7.90748 1.28984 7.87897 1.07456 7.73347 0.93274C7.55379 0.757919 7.26602 0.760527 7.09039 0.940923L7.07097 0.960887C7.2368 0.976535 7.39183 1.04425 7.51243 1.16152Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M4.92154 2.42391C4.95814 2.5035 4.98332 2.59747 4.99267 2.69882L6.4745 1.17652C6.53116 1.11825 6.59717 1.07364 6.6674 1.03758C6.75787 0.864019 6.73143 0.644865 6.58422 0.501609C6.40418 0.326429 6.11542 0.331555 5.94078 0.511321L4.54645 1.94379C4.75517 2.14711 4.82504 2.21573 4.92154 2.42391Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M1.42761 5.99512C1.417 5.19799 1.71709 4.44476 2.27258 3.87425L3.94155 2.15986C4.00693 1.97722 3.98625 1.79332 3.93472 1.68154C3.85891 1.51814 3.81655 1.47731 3.61547 1.28127L1.73876 3.20906C0.789393 4.18424 0.727253 5.69395 1.53535 6.74278C1.46979 6.50168 1.43094 6.25159 1.42761 5.99512Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M2.47414 4.0689L4.35084 2.14111C4.55201 2.33715 4.59437 2.37798 4.67009 2.54138C4.74536 2.70496 4.75948 3.02303 4.52557 3.2653L3.46011 4.36638C3.41883 4.40873 3.42 4.47681 3.46262 4.51827C3.50507 4.55936 3.57306 4.55891 3.61424 4.51656L6.67602 1.37123C6.85057 1.19147 7.13942 1.18634 7.31946 1.36152C7.49914 1.53634 7.50201 1.82546 7.32746 2.00496L5.10912 4.28275C5.06847 4.32447 5.06982 4.39282 5.11253 4.43454C5.15588 4.47645 5.22351 4.47564 5.26442 4.43373L7.82584 1.80064C8.00138 1.62034 8.28924 1.61764 8.46883 1.79255C8.64824 1.96728 8.653 2.25496 8.47755 2.43499L5.91532 5.06728C5.87459 5.10918 5.87566 5.17726 5.91874 5.21908C5.96092 5.26008 6.02908 5.25945 6.06964 5.21773L8.28726 2.93931C8.46191 2.7599 8.75039 2.75397 8.93025 2.92915C9.11038 3.10442 9.11397 3.39453 8.93933 3.57393L6.72036 5.85091C6.67962 5.89291 6.68061 5.96053 6.72378 6.00271C6.76604 6.04381 6.83448 6.04345 6.87503 6.00145L8.18439 4.65496C8.36047 4.47393 8.64904 4.47123 8.82818 4.64534C9.00903 4.82159 9.01262 5.10864 8.83628 5.28958L6.35129 7.84264C5.31029 8.91206 3.59608 8.93553 2.52575 7.89381C1.45534 6.85172 1.43322 5.13805 2.47414 4.0689Z"
        fill="url(#paint3_linear)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="7.47022"
        y1="0.803595"
        x2="7.47022"
        y2="1.526"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.582014" stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="5.63307"
        y1="0.373302"
        x2="5.63307"
        y2="2.69882"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.582014" stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="2.47841"
        y1="1.28127"
        x2="2.47841"
        y2="6.74278"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.582014" stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="5.38791"
        y1="1.23322"
        x2="1.08712"
        y2="9.1125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.582014" stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="9" height="9" fill="white" transform="translate(0.524658)" />
      </clipPath>
    </defs>
  </svg>
)

export default PrayIcon
